<template>
  <el-form
    ref="profileForm"
    class="profileForm"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onUpdate"
  >
    <!-- GENDER -->
    <el-form-item
      class="profileForm__gender"
      :label="$t('profile.form.civilityLabel')"
      prop="gender"
    >
      <el-radio-group v-model="form.gender">
        <el-radio :label="'male'">{{$t('profile.form.civilityMale')}}</el-radio>
        <el-radio :label="'female'">{{ $t('profile.form.civilityFemale') }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- FIRSTNAME & LASTNAME & EMAIL & PHONE_NUMBER -->
    <el-row
      :gutter="56"
      class="profileForm__profile"
    >
      <el-col
        :sm="12"
        :lg="6"
      >
        <el-form-item
          :label="$t('profile.form.firstNameLabel')"
          prop="first_name"
        >
          <el-input
            v-model="form.first_name"
            name="first_name"
            :placeholder="$t('profile.form.firstNamePlaceholder')"
          />
        </el-form-item>
      </el-col>
      <el-col
        :sm="12"
        :lg="6"
      >
        <el-form-item
          :label="$t('profile.form.lastNameLabel')"
          prop="last_name"
        >
          <el-input
            v-model="form.last_name"
            name="last_name"
				    onkeyup="this.value=this.value.toUpperCase()"
				    class="uppercase"
            :placeholder="$t('profile.form.lastNamePlaceholder')"
          />
        </el-form-item>
      </el-col>
      <el-col
        :sm="12"
        :lg="6"
      >
        <el-form-item
          :label="$t('profile.form.emailLabel')"
          prop="email"
        >
          <el-input
            v-model="form.email"
            name="email"
            :placeholder="$t('profile.form.emailPlaceholder')"
          />
        </el-form-item>
      </el-col>
      <el-col
        :sm="12"
        :lg="6"
      >
        <el-form-item
          v-loading="loading"
          :label="$t('profile.form.phoneNumberLabel')"
          prop="phone_number"
        >
          <phone-input
            v-if="!loading"
            :data="{ localValue: form.phone_number, countryCode: form.phone_country_code }"
            @update="updatePhone"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <hr class="profileForm__separator">

    <el-row class="profileForm__continueBlock">
      <el-col :sm="20">
        <p>
          {{ $t('profile.form.continue')}}
        </p>
      </el-col>
      <el-col
        :sm="4"
        class="profileForm__update-container"
      >
        <el-button
          class="profileForm__update"
          type="primary"
          native-type="submit"
          :loading="loading"
        >{{ $t('profile.form.updateButton') }}</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import PhoneInput from "@/components/ui/PhoneInput"
import { mapState } from "vuex"

export default {
  name: "ProfileForm",
  components: {
    PhoneInput
  },
  data: () => ({
    form: {
      gender: "male",
      first_name: null,
      last_name: null,
      phone_number: null,
      phone_country_code: null,
      email: null
    },
    loading: false
  }),
  computed: {
    ...mapState({
      customer: state => state.customer
    }),
    rules() {
      return {
        email: { type: "email", required: true, trigger: 'blur', message: this.$t('forms.validation.invalidEmail') },
        gender: { type: "string", required: true, message: this.$t('forms.validation.invalidGender') },
        first_name: { type: "string", required: true, message: this.$t('forms.validation.invalidFirstName') },
        last_name: { type: "string", required: true, message: this.$t('forms.validation.invalidLastName') },
        phone_number: { type: "string", required: true, message: this.$t('forms.validation.invalidPhoneNumber') },
        phone_country_code: { type: "string", required: true, message: this.$t('forms.validation.invalidPhoneNumber') }
      }
    }
  },
  watch: {
    'customer': {
      immediate: true,
      deep: true,
      handler(newVal) {
        Object.assign(this.form, newVal)
      }
    }
  },
  methods: {
    updatePhone(event) {
      this.form.phone_number = event.phoneNumber
      this.form.phone_country_code = event.countryCode
    },
    async onUpdate() {
      try {
        this.loading = true
        const validation = await this.$refs["profileForm"].validate()

        if (validation) {
					const { ...registration } = this.form

          const r = await this.$store.dispatch("customer/update", {
            registration
          })

          if (r) {
            Object.assign(this.form, r)

            this.$notify({
              type: 'success',
              title: 'Profil',
              message: this.$t('profile.form.updated')
            })
          }
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
$c: '.profileForm';

#{$c} {
  padding: 0 24px;

  &__gender {
    text-align: left;
  }

  &__separator {
    border: 1px solid $--border-color-light;
  }

  &__update-container {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin: 15px 0px;
  }

  &__continueBlock p {
    color: $--color-info;
  }
}
</style>